
const primary900 = '#152456'
const primary400 = '#54679c'
const primary50 = '#e6e9f0'
const primaryContrastText = '#fff'
const secondary500 = '#5da9d8'
const secondaryContrastText = '#fff'
const mediumEmphasis = 'rgba(0,0,0,0.45)'

const palette = {
  primary: {
    contrastText: primaryContrastText,
    main: primary900,
    light: primary50,
  },
  secondary: {
    contrastText: secondaryContrastText,
    main: secondary500
  },
  text: {
    primary: '#707070'
  },
  warning: {
    light: 'rgba(252, 175, 23, 0.1)',
    dark: 'rgba(252, 175, 23, 1)',
    primary: 'rgba(252, 175, 23, 0.57)'
  }
}

export default  {
  overrides: {
    MuiAppBar: {
      root: {boxShadow: 'none'}
    },
    MuiButton: {
      containedSecondary: {
        backgroundColor: secondary500,
        '&disabled': {} // get this value
      }
    },
    MuiCircularProgress: {
      circle: {color: primary400}
    },
    MuiMenu: {
      paper: {
        backgroundColor: primary400
      }
    },
    MuiMenuItem: {
      root: {
        color: primaryContrastText,
        height: 'auto',
        minHeight: '24px',
        whiteSpace: 'initial',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.25)'
        },
      }
    },
    MuiTab: {
      root: {
        '&$selected': {
          backgroundColor: '#fff',
          color: palette.secondary.main
        }
      }
    }
  },
  palette,
  typography: {
    fontFamily: 'Lato, "sans-serif"',
    title: {
      color: primary400,
      fontSize: '0.95rem',
      fontWeight: 'bolder',
      textTransform: 'uppercase'
    },
    subheading: {
      color: mediumEmphasis,
      fontSize: '1.15rem'
    },
    // custom typography properties
    label: {color: primary400},
    highEmphasis: 'rgba(0,0,0,0.65)',
    mediumEmphasis,
  },
  // custom properties
  button: {
    progress: {
      left: '50%',
      marginLeft: -12,
      marginTop: -12,
      position: 'absolute',
      top: '50%'
    }
  },
  desktop: {
    container: {
      bgColor: '#fcfcfc',
      boxShadow: '1px 1px 1px 1px #ccc',
      borderRadius: 5
    }
  },
  links: {
    error: {
      color: '#7182ad'
    }
  },
  borders: {
    defaultSolid: '1px solid rgba(0,0,0,0.12)'
  }
}






// WEBPACK FOOTER //
// ./src/theme.js